<!-- 由 suu 创建于 2021-12-27 星期一 -->
<template>
  <van-overlay :show="true" @click="handelClose">
    <div class="sel-call" v-if="info" @click.stop>
      <!-- 投票成功 -->
      <template v-if="showSuccess">
        <img
          class="sc-s-top"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-pop-top"
          alt=""
        />
        <div class="sc-s-title">打call成功</div>
        <div class="sc-s-num">+ {{ callValue }}票</div>
        <div class="sc-s-info">
          to <img :src="info.c_img" alt="" />
          {{ info.c_name }}
        </div>
        <div class="sc-s-tips">可前往活动页面查看奖品</div>
        <div class="sc-s-btn user-btn" @click="handelClose">关闭</div>
      </template>
      <!-- 进行投票 -->
      <template v-else>
        <img class="sc-img" :src="info.c_img" alt="" />
        <div class="sc-title">营养师</div>
        <div class="sc-name">{{ info.c_name.replace('营养师', '') }}</div>
        <div class="sc-desc">为她投票打call</div>
        <van-stepper
          v-model="callValue"
          input-width="100px"
          button-size="40px"
          min="0"
          :max="info.voteNum"
          integer
        />
        <div class="sc-cur" :class="{ 'sc-cur-0': info.voteNum <= 0 }">
          您还有{{ info.voteNum }}票可以投
        </div>
        <div
          class="sc-btn user-btn"
          @click="bindClock"
          v-if="info.voteNum <= 0"
        >
          去打卡赚投票
        </div>
        <div class="sc-btn user-btn" @click="handelConfirm" v-else>确定</div>
        <div class="sc-btn sc-btn-2 user-btn" @click="handelShare">
          邀请好友为Ta打call
        </div>
      </template>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'sel-call',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {
      callValue: 0,
      showSuccess: false
    }
  },

  computed: {},

  watch: {},

  created() {
    if (this.info.voteNum > 0) {
      this.callValue = 1
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 去打卡
    bindClock() {
      this.$emit('clock')
      this.$emit('close')
    },
    // 关闭
    handelClose() {
      this.$emit('close')
    },
    // 确定投票
    handelConfirm() {
      if (!this.callValue) {
        return
      }
      this.$toast.loading('投票中...')
      this.$http
        .postApp('member/AppVote/vote', {
          vote_cid: this.info.id,
          vote_num: this.callValue
        })
        .then((res) => {
          this.$toast.clear()
          if (res.data.code === 200) {
            this.showSuccess = true
            this.$emit('success')
          }
        })
    },
    // 分享
    handelShare() {
      this.$emit('share', this.info)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sel-call {
  width: 281px;
  box-sizing: border-box;
  background: #f7f7f7;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  .sc-img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3px solid #fff;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
  }
  .sc-title {
    margin-top: 53px;
  }
  .sc-name {
    font-size: 20px;
    font-weight: 500;
  }
  .sc-desc {
    margin-top: 26px;
  }
  ::v-deep .van-stepper {
    width: 243px;
    height: 46px;
    background: #ffffff;
    border-radius: 23px;
    border: 1px solid #f1f1f1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 8px;
    .van-stepper__input,
    .van-stepper__minus,
    .van-stepper__plus {
      background: #fff;
      font-size: 25px;
      font-weight: 500;
      color: #000000;
    }
    .van-stepper__minus--disabled,
    .van-stepper__plus--disabled {
      color: #ccc;
    }
  }
  .sc-cur {
    margin-top: 10px;
    font-weight: 400;
    color: #666;
  }
  .sc-cur-0 {
    color: #ff4652;
  }
  .sc-btn {
    width: 242px;
    height: 44px;
    background: linear-gradient(207deg, #f28a6c 0%, #ed629b 100%);
    border-radius: 24px;
    box-sizing: border-box;
    margin-top: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }
  .sc-btn-2 {
    background: #9c79cf;
    margin-top: 16px;
    margin-bottom: 28px;
  }

  .sc-s-top {
    width: 375px;
    position: absolute;
    top: -145px;
  }
  .sc-s-title {
    color: #fff3d6;
    font-weight: 600;
    font-size: 28px;
    position: absolute;
    top: -41px;
  }
  .sc-s-num {
    margin-top: 20px;
    font-size: 36px;
    font-family: DINPro-Medium, DINPro;
    font-weight: 500;
    color: #ff6f6f;
  }
  .sc-s-info {
    width: 200px;
    box-sizing: border-box;
    margin-top: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666;
    padding: 9px 0;
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    img {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #fff;
      margin: 0 12px;
    }
  }
  .sc-s-tips {
    font-size: 14px;
    margin-top: 14px;
    color: #666;
  }
  .sc-s-btn {
    width: 243px;
    height: 44px;
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid #f1f1f1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 26px;
  }
}
</style>
